import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import './App.css';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { Link } from 'react-router';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
import { NavHeader } from './PageElements/NavHeader';
import { NavButton } from './PageElements/NavButton';
import Footer from './PageElements/Footer';
import ScrollReset from './Tools/ScrollReseter';
import HorizontalLine from './PageElements/HorizontalLine';

export default function HomePage() {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <ScrollReset />
      <div className='wrapper'>
        <NavHeader maxScroll={300} windowWidth={windowWidth} />
        <MainPageHeader windowWidth={windowWidth} />
        <div className='content'>
          <Body windowWidth={windowWidth} />
        </div>
        <Footer imageURL={'Images/WebsiteCoverImage.png'} windowWidth={windowWidth} />
      </div>
    </>
  );
}

function MainPageHeader({ windowWidth }) {
  return (
    <>
      <div id='Header'>
        <svg
          width='100%'
          height={windowWidth > 750 ? '676px' : '500px'}
          viewBox='0 0 1440 700'
          preserveAspectRatio='none'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M0 0V656C0 667.046 8.95431 676 20 676H319.769C339.331 676 358.463 670.263 374.797 659.498L443.135 614.461C459.469 603.696 478.601 597.959 498.163 597.959H962.431C980.985 597.959 999.174 603.121 1014.96 612.868L1093.07 661.091C1108.86 670.838 1127.05 676 1145.61 676H1420C1431.05 676 1440 667.046 1440 656V0H0Z'
            fill='url(#paint0_radial_125_110)'
            filter='url(#shadow)'
          />

          <image
            href='Images/WebsiteCoverImage.png'
            x='0'
            y='0'
            width='100%'
            height='100%'
            opacity='0.03'
            preserveAspectRatio='xMidYMid slice'
            mask='url(#path-mask)'
          />

          <defs>
            <mask id='path-mask' x='0' y='0' width='100%' height='100%'>
              <path
                d='M0 0V656C0 667.046 8.95431 676 20 676H319.769C339.331 676 358.463 670.263 374.797 659.498L443.135 614.461C459.469 603.696 478.601 597.959 498.163 597.959H962.431C980.985 597.959 999.174 603.121 1014.96 612.868L1093.07 661.091C1108.86 670.838 1127.05 676 1145.61 676H1420C1431.05 676 1440 667.046 1440 656V0H0Z'
                fill='white'
              />
            </mask>

            <filter id='shadow' x='0' y='0' width='140%' height='140%'>
              <feDropShadow dx='0' dy='4' stdDeviation='4' floodColor='rgba(0, 0, 0, 0.5)' />
            </filter>

            <radialGradient
              id='paint0_radial_125_110'
              cx='0'
              cy='0'
              r='1'
              gradientUnits='userSpaceOnUse'
              gradientTransform='translate(719.501 289.561) rotate(90) scale(275.567 638.448)'>
              <stop stopColor='#3F5896' stopOpacity='0.70' />
              <stop offset='1' stopColor='#3F5896' />
            </radialGradient>
          </defs>
        </svg>

        <div id='MiddleHeader'>
          <img
            alt=''
            draggable={false}
            width={371}
            height={166}
            style={{ minWidth: '200px', maxWidth: '371px', height: 'auto', width: '100%' }}
            src='/Images/SoknWebsiteLogo.png'
          />
          <h1 className='headerText' style={{ fontSize: windowWidth > 750 ? '48px' : '5vw' }}>
            TECHNOLOGY + MATHEMATICS
          </h1>
          <h2 className='headerText' style={{ fontSize: windowWidth > 750 ? '32px' : '4vw', marginBottom: '10px' }}>
            The Future of Commodity Trading
          </h2>
          <div
            onClick={() => {
              document.getElementById('Videos').scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });
            }}
            style={{
              fontSize: '14px',
              paddingTop: '4px',
              paddingBottom: '4px',
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              paddingLeft: '8px',
              paddingRight: '8px',
              cursor: 'pointer',
            }}
            className='headerActionButton'>
            Let Us Explain
            <img alt='' src='Icons/Play2.svg' height={16} width={16} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '40px', gap: '20px', flexWrap: 'wrap' }}>
            <Link draggable={false} reloadDocument to={'/ourapproach#soknmathmodels'} className='headerAltButton'>
              Our Math/Models <img alt='' src='Icons/NewTab.svg' height={20} width={20} />
            </Link>
            <Link draggable={false} to={'/provenandevolving'} className='headerButton'>
              Proven & Evolving <img alt='' src='Icons/NewTab.svg' height={20} width={20} />
            </Link>
          </div>
        </div>

        {windowWidth > 750 && (
          <>
            <div style={{ position: 'absolute', top: '100px', left: '4%' }}>
              <svg width='384' height='99' viewBox='0 0 384 99' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M0 1H246.927C269.719 1 291.623 9.8434 308.026 25.6685L383 98' stroke='url(#paint0_linear_73_562)' strokeWidth='2' />
                <defs>
                  <linearGradient id='paint0_linear_73_562' x1='0' y1='1' x2='382.611' y2='99.5102' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#749DFF' />
                    <stop offset='1' stopColor='#749DFF' stopOpacity='0' />
                  </linearGradient>
                </defs>
              </svg>

              <div style={{ position: 'absolute', top: '-24px', left: '20%' }}>
                <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <circle cx='24' cy='24' r='19' fill='#3F5896' />
                  <g clipPath='url(#clip0_73_590)'>
                    <path d='M9.75 24H20.25L22 30H8L9.75 24Z' fill='white' />
                    <path d='M17.75 16H28.25L30 22H16L17.75 16Z' fill='white' />
                    <path d='M27.75 24H38.25L40 30H26L27.75 24Z' fill='white' />
                    <circle cx='24' cy='24' r='19.5' stroke='#749DFF' />
                  </g>
                  <defs>
                    <clipPath id='clip0_73_590'>
                      <rect width='48' height='48' fill='white' />
                    </clipPath>
                  </defs>
                </svg>
                <svg width='66' height='14' viewBox='0 0 66 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <circle cx='2' cy='7' r='2' fill='white' />
                  <path
                    d='M12.648 11C11.732 11 11.054 10.782 10.614 10.346C10.178 9.906 9.96 9.228 9.96 8.312V5.552C9.96 4.628 10.178 3.948 10.614 3.512C11.05 3.072 11.724 2.856 12.636 2.864H14.088C14.84 2.864 15.414 3.02 15.81 3.332C16.206 3.64 16.436 4.128 16.5 4.796C16.524 4.964 16.492 5.092 16.404 5.18C16.316 5.268 16.188 5.312 16.02 5.312C15.716 5.312 15.54 5.144 15.492 4.808C15.452 4.44 15.324 4.192 15.108 4.064C14.896 3.936 14.556 3.872 14.088 3.872H12.636C12.212 3.868 11.878 3.916 11.634 4.016C11.394 4.116 11.222 4.29 11.118 4.538C11.018 4.782 10.968 5.12 10.968 5.552V8.312C10.968 8.74 11.018 9.076 11.118 9.32C11.222 9.564 11.396 9.738 11.64 9.842C11.884 9.942 12.22 9.992 12.648 9.992H14.088C14.46 9.992 14.75 9.952 14.958 9.872C15.17 9.788 15.318 9.642 15.402 9.434C15.486 9.226 15.528 8.932 15.528 8.552V7.988L14.592 7.976C14.256 7.976 14.088 7.808 14.088 7.472C14.088 7.136 14.256 6.968 14.592 6.968L16.032 6.98C16.368 6.98 16.536 7.148 16.536 7.484V8.552C16.536 9.404 16.338 10.026 15.942 10.418C15.546 10.806 14.928 11 14.088 11H12.648ZM20.2104 11C19.4144 11 18.8224 10.808 18.4344 10.424C18.0504 10.04 17.8584 9.452 17.8584 8.66V7.268C17.8584 6.464 18.0504 5.872 18.4344 5.492C18.8224 5.108 19.4144 4.916 20.2104 4.916H21.1944C21.9944 4.916 22.5864 5.108 22.9704 5.492C23.3544 5.876 23.5464 6.468 23.5464 7.268V8.648C23.5464 9.444 23.3544 10.036 22.9704 10.424C22.5864 10.808 21.9944 11 21.1944 11H20.2104ZM18.8664 8.66C18.8664 9.176 18.9604 9.528 19.1484 9.716C19.3364 9.9 19.6904 9.992 20.2104 9.992H21.1944C21.7184 9.992 22.0724 9.898 22.2564 9.71C22.4444 9.522 22.5384 9.168 22.5384 8.648V7.268C22.5384 6.744 22.4444 6.39 22.2564 6.206C22.0724 6.018 21.7184 5.924 21.1944 5.924H20.2104C19.8624 5.924 19.5904 5.964 19.3944 6.044C19.2024 6.12 19.0664 6.256 18.9864 6.452C18.9064 6.644 18.8664 6.916 18.8664 7.268V8.66ZM27.5639 11C26.9519 11 26.4959 10.85 26.1959 10.55C25.8999 10.246 25.7519 9.788 25.7519 9.176V3.056C25.7519 2.72 25.9199 2.552 26.2559 2.552C26.5919 2.552 26.7599 2.72 26.7599 3.056V9.176C26.7599 9.5 26.8119 9.718 26.9159 9.83C27.0239 9.938 27.2399 9.992 27.5639 9.992C27.9079 9.992 28.0799 10.16 28.0799 10.496C28.0919 10.832 27.9199 11 27.5639 11ZM31.6948 11C30.8988 11 30.3068 10.808 29.9188 10.424C29.5348 10.036 29.3428 9.444 29.3428 8.648V7.268C29.3428 6.468 29.5348 5.876 29.9188 5.492C30.3068 5.108 30.8988 4.916 31.6948 4.916H34.0228V3.056C34.0228 2.72 34.1908 2.552 34.5268 2.552C34.8628 2.552 35.0308 2.72 35.0308 3.056V10.496C35.0308 10.832 34.8628 11 34.5268 11C34.1908 11 34.0228 10.832 34.0228 10.496V10.412C33.8348 10.604 33.5888 10.75 33.2848 10.85C32.9808 10.95 32.6028 11 32.1508 11H31.6948ZM31.6948 9.992H32.1508C32.6788 9.992 33.1228 9.924 33.4828 9.788C33.8428 9.652 34.0228 9.444 34.0228 9.164V5.924H31.6948C31.1748 5.924 30.8208 6.02 30.6328 6.212C30.4448 6.4 30.3508 6.752 30.3508 7.268V8.648C30.3508 9.168 30.4448 9.522 30.6328 9.71C30.8248 9.898 31.1788 9.992 31.6948 9.992Z'
                    fill='white'
                  />
                </svg>
              </div>
            </div>

            <div style={{ position: 'absolute', top: '450px', left: '4%' }}>
              <svg width='384' height='99' viewBox='0 0 384 99' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M0 98H246.927C269.719 98 291.623 89.1566 308.026 73.3315L383 1' stroke='url(#paint0_linear_73_565)' strokeWidth='2' />
                <defs>
                  <linearGradient id='paint0_linear_73_565' x1='0' y1='98' x2='382.611' y2='-0.510185' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#749DFF' />
                    <stop offset='1' stopColor='#749DFF' stopOpacity='0' />
                  </linearGradient>
                </defs>
              </svg>

              <div style={{ position: 'absolute', bottom: '-24px', left: '40%' }}>
                <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <circle cx='24' cy='24' r='19' fill='#3F5896' />
                  <g clipPath='url(#clip0_73_569)'>
                    <circle cx='24' cy='24' r='19.5' stroke='#749DFF' />
                    <path d='M32 28C32 32.9706 29.5228 36 24 36C18.4772 36 16 32.9706 16 28C16 21.6 24 12 24 12C24 12 32 21.6 32 28Z' fill='white' />
                  </g>
                  <defs>
                    <clipPath id='clip0_73_569'>
                      <rect width='48' height='48' fill='white' />
                    </clipPath>
                  </defs>
                </svg>

                <div style={{ position: 'absolute', top: '-10px', left: '80%' }}>
                  <svg width='66' height='14' viewBox='0 0 66 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <circle cx='2' cy='7' r='2' fill='white' />
                    <path
                      d='M12.648 11C11.732 11 11.054 10.782 10.614 10.346C10.178 9.906 9.96 9.228 9.96 8.312V5.552C9.96 4.628 10.178 3.948 10.614 3.512C11.05 3.072 11.724 2.856 12.636 2.864H14.088C14.84 2.864 15.414 3.02 15.81 3.332C16.206 3.64 16.436 4.128 16.5 4.796C16.524 4.964 16.492 5.092 16.404 5.18C16.316 5.268 16.188 5.312 16.02 5.312C15.716 5.312 15.54 5.144 15.492 4.808C15.452 4.44 15.324 4.192 15.108 4.064C14.896 3.936 14.556 3.872 14.088 3.872H12.636C12.212 3.868 11.878 3.916 11.634 4.016C11.394 4.116 11.222 4.29 11.118 4.538C11.018 4.782 10.968 5.12 10.968 5.552V8.312C10.968 8.74 11.018 9.076 11.118 9.32C11.222 9.564 11.396 9.738 11.64 9.842C11.884 9.942 12.22 9.992 12.648 9.992H14.088C14.556 9.992 14.896 9.928 15.108 9.8C15.324 9.668 15.452 9.42 15.492 9.056C15.54 8.72 15.716 8.552 16.02 8.552C16.188 8.552 16.316 8.596 16.404 8.684C16.492 8.772 16.524 8.9 16.5 9.068C16.436 9.74 16.206 10.23 15.81 10.538C15.414 10.846 14.84 11 14.088 11H12.648ZM19.1075 11C18.7715 11 18.6035 10.832 18.6035 10.496V5.42C18.6035 5.084 18.7715 4.916 19.1075 4.916C19.4435 4.916 19.6115 5.084 19.6115 5.42V5.888C19.8475 5.568 20.1475 5.326 20.5115 5.162C20.8795 4.998 21.2995 4.916 21.7715 4.916C22.1075 4.916 22.2755 5.084 22.2755 5.42C22.2755 5.756 22.1075 5.924 21.7715 5.924C21.0795 5.924 20.5515 6.052 20.1875 6.308C19.8235 6.564 19.6315 6.902 19.6115 7.322V10.496C19.6115 10.832 19.4435 11 19.1075 11ZM28.6686 4.916C29.0046 4.916 29.1726 5.084 29.1726 5.42V10.496C29.1726 10.832 29.0046 11 28.6686 11C28.3326 11 28.1646 10.832 28.1646 10.496V10.298C27.7406 10.766 27.1166 11 26.2926 11H25.9566C25.1606 11 24.5686 10.808 24.1806 10.424C23.7966 10.036 23.6046 9.444 23.6046 8.648V5.42C23.6046 5.084 23.7726 4.916 24.1086 4.916C24.4446 4.916 24.6126 5.084 24.6126 5.42V8.648C24.6126 9.168 24.7066 9.522 24.8946 9.71C25.0866 9.898 25.4406 9.992 25.9566 9.992H26.2926C26.7726 9.992 27.1906 9.936 27.5466 9.824C27.9066 9.712 28.1126 9.54 28.1646 9.308V5.42C28.1646 5.084 28.3326 4.916 28.6686 4.916ZM33.7339 11C32.9379 11 32.3459 10.808 31.9579 10.424C31.5739 10.036 31.3819 9.444 31.3819 8.648V7.268C31.3819 6.468 31.5739 5.876 31.9579 5.492C32.3459 5.108 32.9379 4.916 33.7339 4.916H36.0619V3.056C36.0619 2.72 36.2299 2.552 36.5659 2.552C36.9019 2.552 37.0699 2.72 37.0699 3.056V10.496C37.0699 10.832 36.9019 11 36.5659 11C36.2299 11 36.0619 10.832 36.0619 10.496V10.412C35.8739 10.604 35.6279 10.75 35.3239 10.85C35.0199 10.95 34.6419 11 34.1899 11H33.7339ZM33.7339 9.992H34.1899C34.7179 9.992 35.1619 9.924 35.5219 9.788C35.8819 9.652 36.0619 9.444 36.0619 9.164V5.924H33.7339C33.2139 5.924 32.8599 6.02 32.6719 6.212C32.4839 6.4 32.3899 6.752 32.3899 7.268V8.648C32.3899 9.168 32.4839 9.522 32.6719 9.71C32.8639 9.898 33.2179 9.992 33.7339 9.992ZM40.1711 8.372V8.66C40.1711 9.176 40.2651 9.528 40.4531 9.716C40.6411 9.9 40.9951 9.992 41.5151 9.992H42.4991C42.9071 9.992 43.2091 9.954 43.4051 9.878C43.6011 9.802 43.7311 9.668 43.7951 9.476C43.8391 9.324 43.8991 9.208 43.9751 9.128C44.0551 9.048 44.1751 9.008 44.3351 9.008C44.5031 9.008 44.6311 9.052 44.7191 9.14C44.8071 9.228 44.8351 9.356 44.8031 9.524C44.7151 10.02 44.4791 10.39 44.0951 10.634C43.7111 10.878 43.1791 11 42.4991 11H41.5151C40.7191 11 40.1271 10.808 39.7391 10.424C39.3551 10.04 39.1631 9.452 39.1631 8.66V7.268C39.1631 6.456 39.3551 5.86 39.7391 5.48C40.1271 5.096 40.7191 4.908 41.5151 4.916H42.4991C43.2991 4.916 43.8911 5.108 44.2751 5.492C44.6591 5.872 44.8511 6.464 44.8511 7.268V7.868C44.8511 8.204 44.6831 8.372 44.3471 8.372H40.1711ZM41.5151 5.924C40.9951 5.916 40.6411 6.006 40.4531 6.194C40.2651 6.382 40.1711 6.74 40.1711 7.268V7.364H43.8431V7.268C43.8431 6.744 43.7491 6.39 43.5611 6.206C43.3771 6.018 43.0231 5.924 42.4991 5.924H41.5151ZM53.23 11C52.314 11 51.636 10.782 51.196 10.346C50.76 9.906 50.542 9.228 50.542 8.312V5.54C50.542 4.616 50.762 3.938 51.202 3.506C51.642 3.07 52.318 2.856 53.23 2.864H54.67C55.59 2.864 56.268 3.082 56.704 3.518C57.14 3.954 57.358 4.632 57.358 5.552V8.312C57.358 9.228 57.14 9.906 56.704 10.346C56.268 10.782 55.59 11 54.67 11H53.23ZM53.23 9.992H54.67C55.098 9.992 55.434 9.942 55.678 9.842C55.922 9.738 56.094 9.564 56.194 9.32C56.298 9.076 56.35 8.74 56.35 8.312V5.552C56.35 5.128 56.298 4.794 56.194 4.55C56.094 4.306 55.922 4.132 55.678 4.028C55.434 3.924 55.098 3.872 54.67 3.872H53.23C52.806 3.868 52.472 3.916 52.228 4.016C51.984 4.116 51.81 4.288 51.706 4.532C51.602 4.776 51.55 5.112 51.55 5.54V8.312C51.55 8.74 51.6 9.076 51.7 9.32C51.804 9.564 51.978 9.738 52.222 9.842C52.466 9.942 52.802 9.992 53.23 9.992ZM59.8965 3.932C59.5165 3.932 59.3265 3.74 59.3265 3.356V3.002C59.3265 2.626 59.5165 2.438 59.8965 2.438H60.2445C60.6085 2.438 60.7905 2.626 60.7905 3.002V3.356C60.7905 3.74 60.6085 3.932 60.2445 3.932H59.8965ZM60.0645 11C59.7285 11 59.5605 10.832 59.5605 10.496V5.42C59.5605 5.084 59.7285 4.916 60.0645 4.916C60.4005 4.916 60.5685 5.084 60.5685 5.42V10.496C60.5685 10.832 60.4005 11 60.0645 11ZM64.8764 11C64.2644 11 63.8084 10.85 63.5084 10.55C63.2124 10.246 63.0644 9.788 63.0644 9.176V3.056C63.0644 2.72 63.2324 2.552 63.5684 2.552C63.9044 2.552 64.0724 2.72 64.0724 3.056V9.176C64.0724 9.5 64.1244 9.718 64.2284 9.83C64.3364 9.938 64.5524 9.992 64.8764 9.992C65.2204 9.992 65.3924 10.16 65.3924 10.496C65.4044 10.832 65.2324 11 64.8764 11Z'
                      fill='white'
                    />
                  </svg>
                </div>
              </div>
            </div>

            <div style={{ position: 'absolute', top: '450px', right: '4%' }}>
              <svg width='384' height='99' viewBox='0 0 384 99' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M384 98H137.073C114.281 98 92.3775 89.1566 75.9742 73.3315L1 1' stroke='url(#paint0_linear_73_567)' strokeWidth='2' />
                <defs>
                  <linearGradient id='paint0_linear_73_567' x1='384' y1='98' x2='1.38882' y2='-0.510185' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#749DFF' />
                    <stop offset='1' stopColor='#749DFF' stopOpacity='0' />
                  </linearGradient>
                </defs>
              </svg>

              <div style={{ position: 'absolute', bottom: '-24px', left: '70%' }}>
                <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <circle cx='24' cy='24' r='19' fill='#3F5896' />
                  <g clipPath='url(#clip0_73_583)'>
                    <circle cx='24' cy='24' r='19.5' stroke='#749DFF' />
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M23.9999 38C28.4182 38 31.9999 35.732 31.9999 28C31.9999 26.717 35.1846 22.3642 34.9999 21L25.9999 27L11.9999 16C10.9999 18 15.9999 23 15.9999 28C15.9999 35.732 19.5816 38 23.9999 38ZM17.9999 19L21.9999 22L25.9999 24L31.3859 22C30.1797 15.8224 27.327 10 23.9999 10C21.3691 10 19.458 14.422 17.9999 19Z'
                      fill='white'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_73_583'>
                      <rect width='48' height='48' fill='white' />
                    </clipPath>
                  </defs>
                </svg>

                <div style={{ position: 'absolute', top: '-14px', left: '-80%' }}>
                  <svg width='43' height='14' viewBox='0 0 43 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <circle cx='2' cy='7' r='2' fill='white' />
                    <path
                      d='M12.648 11C11.732 11 11.054 10.782 10.614 10.346C10.178 9.906 9.96 9.228 9.96 8.312V5.552C9.96 4.628 10.178 3.948 10.614 3.512C11.05 3.072 11.724 2.856 12.636 2.864H14.088C14.84 2.864 15.414 3.02 15.81 3.332C16.206 3.64 16.436 4.128 16.5 4.796C16.524 4.964 16.492 5.092 16.404 5.18C16.316 5.268 16.188 5.312 16.02 5.312C15.716 5.312 15.54 5.144 15.492 4.808C15.452 4.44 15.324 4.192 15.108 4.064C14.896 3.936 14.556 3.872 14.088 3.872H12.636C12.212 3.868 11.878 3.916 11.634 4.016C11.394 4.116 11.222 4.29 11.118 4.538C11.018 4.782 10.968 5.12 10.968 5.552V8.312C10.968 8.74 11.018 9.076 11.118 9.32C11.222 9.564 11.396 9.738 11.64 9.842C11.884 9.942 12.22 9.992 12.648 9.992H14.088C14.556 9.992 14.896 9.928 15.108 9.8C15.324 9.668 15.452 9.42 15.492 9.056C15.54 8.72 15.716 8.552 16.02 8.552C16.188 8.552 16.316 8.596 16.404 8.684C16.492 8.772 16.524 8.9 16.5 9.068C16.436 9.74 16.206 10.23 15.81 10.538C15.414 10.846 14.84 11 14.088 11H12.648ZM20.187 11C19.391 11 18.799 10.808 18.411 10.424C18.027 10.04 17.835 9.452 17.835 8.66V7.268C17.835 6.464 18.027 5.872 18.411 5.492C18.799 5.108 19.391 4.916 20.187 4.916H21.171C21.971 4.916 22.563 5.108 22.947 5.492C23.331 5.876 23.523 6.468 23.523 7.268V8.648C23.523 9.444 23.331 10.036 22.947 10.424C22.563 10.808 21.971 11 21.171 11H20.187ZM18.843 8.66C18.843 9.176 18.937 9.528 19.125 9.716C19.313 9.9 19.667 9.992 20.187 9.992H21.171C21.695 9.992 22.049 9.898 22.233 9.71C22.421 9.522 22.515 9.168 22.515 8.648V7.268C22.515 6.744 22.421 6.39 22.233 6.206C22.049 6.018 21.695 5.924 21.171 5.924H20.187C19.839 5.924 19.567 5.964 19.371 6.044C19.179 6.12 19.043 6.256 18.963 6.452C18.883 6.644 18.843 6.916 18.843 7.268V8.66ZM26.2325 11C25.8965 11 25.7285 10.832 25.7285 10.496V5.42C25.7285 5.084 25.8965 4.916 26.2325 4.916C26.5685 4.916 26.7365 5.084 26.7365 5.42V5.888C26.9725 5.568 27.2725 5.326 27.6365 5.162C28.0045 4.998 28.4245 4.916 28.8965 4.916C29.2325 4.916 29.4005 5.084 29.4005 5.42C29.4005 5.756 29.2325 5.924 28.8965 5.924C28.2045 5.924 27.6765 6.052 27.3125 6.308C26.9485 6.564 26.7565 6.902 26.7365 7.322V10.496C26.7365 10.832 26.5685 11 26.2325 11ZM31.3536 11C31.0176 11 30.8496 10.832 30.8496 10.496V5.42C30.8496 5.084 31.0176 4.916 31.3536 4.916C31.6896 4.916 31.8576 5.084 31.8576 5.42V5.618C32.2816 5.15 32.9056 4.916 33.7296 4.916H34.0656C34.8656 4.916 35.4576 5.108 35.8416 5.492C36.2256 5.876 36.4176 6.468 36.4176 7.268V10.496C36.4176 10.832 36.2496 11 35.9136 11C35.5776 11 35.4096 10.832 35.4096 10.496V7.268C35.4096 6.744 35.3136 6.39 35.1216 6.206C34.9336 6.018 34.5816 5.924 34.0656 5.924H33.7296C33.2496 5.924 32.8316 5.98 32.4756 6.092C32.1196 6.2 31.9136 6.372 31.8576 6.608V10.496C31.8576 10.832 31.6896 11 31.3536 11Z'
                      fill='white'
                    />
                  </svg>
                </div>
              </div>
            </div>

            <div style={{ position: 'absolute', top: '100px', right: '4%' }}>
              <svg width='384' height='99' viewBox='0 0 384 99' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M384 1H137.073C114.281 1 92.3775 9.8434 75.9742 25.6685L1 98' stroke='url(#paint0_linear_73_566)' strokeWidth='2' />
                <defs>
                  <linearGradient id='paint0_linear_73_566' x1='384' y1='1' x2='1.38882' y2='99.5102' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#749DFF' />
                    <stop offset='1' stopColor='#749DFF' stopOpacity='0' />
                  </linearGradient>
                </defs>
              </svg>

              <div style={{ position: 'absolute', top: '-24px', left: '40%' }}>
                <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <circle cx='24' cy='24' r='19' fill='#3F5896' />
                  <g clipPath='url(#clip0_73_569)'>
                    <circle cx='24' cy='24' r='19.5' stroke='#749DFF' />
                    <path d='M32 28C32 32.9706 29.5228 36 24 36C18.4772 36 16 32.9706 16 28C16 21.6 24 12 24 12C24 12 32 21.6 32 28Z' fill='white' />
                  </g>
                  <defs>
                    <clipPath id='clip0_73_569'>
                      <rect width='48' height='48' fill='white' />
                    </clipPath>
                  </defs>
                </svg>

                <div style={{ position: 'absolute', bottom: '-15px', right: '40%' }}>
                  <svg width='66' height='14' viewBox='0 0 66 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <circle cx='2' cy='7' r='2' fill='white' />
                    <path
                      d='M10.752 11C10.416 11 10.248 10.832 10.248 10.496V3.368C10.248 3.032 10.416 2.864 10.752 2.864H13.884C14.52 2.864 15.008 3.032 15.348 3.368C15.692 3.704 15.864 4.184 15.864 4.808V5.132C15.864 5.672 15.694 6.09 15.354 6.386C15.99 6.742 16.308 7.392 16.308 8.336V8.744C16.308 9.48 16.112 10.04 15.72 10.424C15.332 10.808 14.772 11 14.04 11H10.752ZM11.256 9.992H14.04C14.492 9.992 14.814 9.896 15.006 9.704C15.202 9.508 15.3 9.188 15.3 8.744V8.336C15.3 7.892 15.206 7.576 15.018 7.388C14.83 7.196 14.504 7.1 14.04 7.1H11.256V9.992ZM11.256 6.092H14.1C14.392 6.092 14.59 6.002 14.694 5.822C14.802 5.642 14.856 5.412 14.856 5.132V4.808C14.856 4.46 14.784 4.218 14.64 4.082C14.496 3.942 14.244 3.872 13.884 3.872H11.256V6.092ZM18.8262 11C18.4902 11 18.3222 10.832 18.3222 10.496V5.42C18.3222 5.084 18.4902 4.916 18.8262 4.916C19.1622 4.916 19.3302 5.084 19.3302 5.42V5.888C19.5662 5.568 19.8662 5.326 20.2302 5.162C20.5982 4.998 21.0182 4.916 21.4902 4.916C21.8262 4.916 21.9942 5.084 21.9942 5.42C21.9942 5.756 21.8262 5.924 21.4902 5.924C20.7982 5.924 20.2702 6.052 19.9062 6.308C19.5422 6.564 19.3502 6.902 19.3302 7.322V10.496C19.3302 10.832 19.1622 11 18.8262 11ZM23.9289 8.372V8.66C23.9289 9.176 24.0229 9.528 24.2109 9.716C24.3989 9.9 24.7529 9.992 25.2729 9.992H26.2569C26.6649 9.992 26.9669 9.954 27.1629 9.878C27.3589 9.802 27.4889 9.668 27.5529 9.476C27.5969 9.324 27.6569 9.208 27.7329 9.128C27.8129 9.048 27.9329 9.008 28.0929 9.008C28.2609 9.008 28.3889 9.052 28.4769 9.14C28.5649 9.228 28.5929 9.356 28.5609 9.524C28.4729 10.02 28.2369 10.39 27.8529 10.634C27.4689 10.878 26.9369 11 26.2569 11H25.2729C24.4769 11 23.8849 10.808 23.4969 10.424C23.1129 10.04 22.9209 9.452 22.9209 8.66V7.268C22.9209 6.456 23.1129 5.86 23.4969 5.48C23.8849 5.096 24.4769 4.908 25.2729 4.916H26.2569C27.0569 4.916 27.6489 5.108 28.0329 5.492C28.4169 5.872 28.6089 6.464 28.6089 7.268V7.868C28.6089 8.204 28.4409 8.372 28.1049 8.372H23.9289ZM25.2729 5.924C24.7529 5.916 24.3989 6.006 24.2109 6.194C24.0229 6.382 23.9289 6.74 23.9289 7.268V7.364H27.6009V7.268C27.6009 6.744 27.5069 6.39 27.3189 6.206C27.1349 6.018 26.7809 5.924 26.2569 5.924H25.2729ZM31.3184 11C30.9824 11 30.8144 10.832 30.8144 10.496V5.42C30.8144 5.084 30.9824 4.916 31.3184 4.916C31.6544 4.916 31.8224 5.084 31.8224 5.42V5.618C32.2464 5.15 32.8704 4.916 33.6944 4.916H34.0304C34.8304 4.916 35.4224 5.108 35.8064 5.492C36.1904 5.876 36.3824 6.468 36.3824 7.268V10.496C36.3824 10.832 36.2144 11 35.8784 11C35.5424 11 35.3744 10.832 35.3744 10.496V7.268C35.3744 6.744 35.2784 6.39 35.0864 6.206C34.8984 6.018 34.5464 5.924 34.0304 5.924H33.6944C33.2144 5.924 32.7964 5.98 32.4404 6.092C32.0844 6.2 31.8784 6.372 31.8224 6.608V10.496C31.8224 10.832 31.6544 11 31.3184 11ZM41.3277 11C40.5357 11 39.9517 10.812 39.5757 10.436C39.1997 10.06 39.0117 9.48 39.0117 8.696V5.924H38.4237C38.0877 5.924 37.9197 5.756 37.9197 5.42C37.9197 5.084 38.0877 4.916 38.4237 4.916H39.0117V4.04C39.0117 3.704 39.1797 3.536 39.5157 3.536C39.8517 3.536 40.0197 3.704 40.0197 4.04V4.916H41.3997C41.7357 4.916 41.9037 5.084 41.9037 5.42C41.9037 5.756 41.7357 5.924 41.3997 5.924H40.0197V8.696C40.0197 9.204 40.1117 9.548 40.2957 9.728C40.4797 9.904 40.8237 9.992 41.3277 9.992C41.4837 9.992 41.6057 10.032 41.6937 10.112C41.7857 10.192 41.8317 10.32 41.8317 10.496C41.8317 10.832 41.6637 11 41.3277 11ZM49.9605 11C49.0445 11 48.3665 10.782 47.9265 10.346C47.4905 9.906 47.2725 9.228 47.2725 8.312V5.54C47.2725 4.616 47.4925 3.938 47.9325 3.506C48.3725 3.07 49.0485 2.856 49.9605 2.864H51.4005C52.3205 2.864 52.9985 3.082 53.4345 3.518C53.8705 3.954 54.0885 4.632 54.0885 5.552V8.312C54.0885 9.228 53.8705 9.906 53.4345 10.346C52.9985 10.782 52.3205 11 51.4005 11H49.9605ZM49.9605 9.992H51.4005C51.8285 9.992 52.1645 9.942 52.4085 9.842C52.6525 9.738 52.8245 9.564 52.9245 9.32C53.0285 9.076 53.0805 8.74 53.0805 8.312V5.552C53.0805 5.128 53.0285 4.794 52.9245 4.55C52.8245 4.306 52.6525 4.132 52.4085 4.028C52.1645 3.924 51.8285 3.872 51.4005 3.872H49.9605C49.5365 3.868 49.2025 3.916 48.9585 4.016C48.7145 4.116 48.5405 4.288 48.4365 4.532C48.3325 4.776 48.2805 5.112 48.2805 5.54V8.312C48.2805 8.74 48.3305 9.076 48.4305 9.32C48.5345 9.564 48.7085 9.738 48.9525 9.842C49.1965 9.942 49.5325 9.992 49.9605 9.992ZM56.627 3.932C56.247 3.932 56.057 3.74 56.057 3.356V3.002C56.057 2.626 56.247 2.438 56.627 2.438H56.975C57.339 2.438 57.521 2.626 57.521 3.002V3.356C57.521 3.74 57.339 3.932 56.975 3.932H56.627ZM56.795 11C56.459 11 56.291 10.832 56.291 10.496V5.42C56.291 5.084 56.459 4.916 56.795 4.916C57.131 4.916 57.299 5.084 57.299 5.42V10.496C57.299 10.832 57.131 11 56.795 11ZM61.6069 11C60.9949 11 60.5389 10.85 60.2389 10.55C59.9429 10.246 59.7949 9.788 59.7949 9.176V3.056C59.7949 2.72 59.9629 2.552 60.2989 2.552C60.6349 2.552 60.8029 2.72 60.8029 3.056V9.176C60.8029 9.5 60.8549 9.718 60.9589 9.83C61.0669 9.938 61.2829 9.992 61.6069 9.992C61.9509 9.992 62.1229 10.16 62.1229 10.496C62.1349 10.832 61.9629 11 61.6069 11Z'
                      fill='white'
                    />
                  </svg>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

function Body({ windowWidth }) {
  return (
    <>
      <div
        style={{
          display: windowWidth > 1430 ? 'flex' : 'none',
          justifyContent: 'space-between',
          position: 'absolute',
          marginTop: '20px',
          userSelect: 'none',
          pointerEvents: 'none',
          left: 0,
          paddingLeft: '30px',
          paddingRight: '30px',
        }}
        className='full'>
        <svg width='190' height='2700' viewBox='0 0 190 2415' preserveAspectRatio='none' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M190 2314H21C9.95431 2314 0.999999 2305.05 0.999999 2294V21C0.999999 9.95432 9.9543 1 21 1H190'
            stroke='url(#paint0_linear_73_632)'
            strokeWidth='2'
          />
          <defs>
            <linearGradient id='paint0_linear_73_632' x1='1.00001' y1='1156.43' x2='190.501' y2='1156.43' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#5472B8' />
              <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
            </linearGradient>
          </defs>
        </svg>

        <svg width='190' height='2700' viewBox='0 0 190 2415' preserveAspectRatio='none' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M0 2314H169C180.046 2314 189 2305.05 189 2294V21C189 9.95432 180.046 1 169 1H0'
            stroke='url(#paint0_linear_73_631)'
            strokeWidth='2'
          />
          <defs>
            <linearGradient id='paint0_linear_73_631' x1='189' y1='1156.43' x2='-0.501326' y2='1156.43' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#5472B8' />
              <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
            </linearGradient>
          </defs>
        </svg>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          paddingLeft: windowWidth > 800 ? '100px' : '0px',
          paddingRight: windowWidth > 800 ? '100px' : '0px',
          gap: '50px',
        }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            width: '80%',
            maxWidth: '1340px',
          }}>
          <h1 className='bodyHeader'>Who Is Sókn Engineering</h1>

          <p style={{ lineHeight: '150%', fontFamily: 'Lato' }}>
            In a world saturated with algorithmic trading tools and off-the-shelf AI hype, Sókn Engineering is forging a radically different path. At
            the heart of this innovation is Lagertha, a proprietary intelligent forecasting system that leverages modular calculus and rigorous
            scientific modeling with mathematical precision. Far from being just another predictive model, Lagertha is engineered to function like a
            living, learning entity—an adaptive system designed to understand and anticipate market behavior with unprecedented depth and accuracy.
          </p>

          <p style={{ lineHeight: '150%', fontFamily: 'Lato' }}>
            Sókn Engineering is more than a financial technology company—we are a team of innovators, mathematicians, and market strategists driven by
            a vision to redefine predictive analytics. Our expertise spans AI, market intelligence, and commodities forecasting, ensuring we remain at
            the forefront of financial technology. With a culture built on precision, creativity, and data-driven insights, we continue to push the
            boundaries of what’s possible in automated trading and financial modeling.
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}>
          <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', alignItems: 'center', width: '100%', gap: '20px' }}>
            {windowWidth > 750 && (
              <svg width='2' height='100' viewBox='0 0 2 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M1 0V100' stroke='url(#paint0_linear_73_871)' />
                <defs>
                  <linearGradient id='paint0_linear_73_871' x1='1' y1='0.0627352' x2='26.0333' y2='6.49337' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#BC9C4E' />
                  </linearGradient>
                </defs>
              </svg>
            )}

            <svg width='2' height='167' viewBox='0 0 2 167' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M1 0V166.5' stroke='url(#paint0_linear_73_867)' />
              <defs>
                <linearGradient id='paint0_linear_73_867' x1='1' y1='0.104454' x2='27.0648' y2='4.12584' gradientUnits='userSpaceOnUse'>
                  <stop stopColor='#BC9C4E' />
                </linearGradient>
              </defs>
            </svg>

            {/* <img
              alt=''
              src='Images/TeamPhotoWebsite.png'
              height={346}
              width={614}
              style={{
                borderRadius: '10px',
                border: '1px solid #bc9c4e',
                boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
                minWidth: '200px',
                maxWidth: '614px',
                height: 'auto',
                width: 'auto',
              }}
            /> */}

            <iframe
              src='https://player.vimeo.com/video/1097003242?h=efce9a95cd&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
              frameborder='0'
              allow='autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share'
              style={{
                aspectRatio: '16 / 9',
                borderRadius: '10px',
                border: '1px solid #bc9c4e',
                boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
                position: 'relative',
                minWidth: '300px',
                maxWidth: '800px',
                height: 'auto',
                width: '100%',
              }}
              title='SokN - engineering'></iframe>
            <script src='https://player.vimeo.com/api/player.js'></script>

            {windowWidth > 750 && (
              <svg width='2' height='167' viewBox='0 0 2 167' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M1 0V166.5' stroke='url(#paint0_linear_73_867)' />
                <defs>
                  <linearGradient id='paint0_linear_73_867' x1='1' y1='0.104454' x2='27.0648' y2='4.12584' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#BC9C4E' />
                  </linearGradient>
                </defs>
              </svg>
            )}

            <svg width='2' height='100' viewBox='0 0 2 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M1 0V100' stroke='url(#paint0_linear_73_871)' />
              <defs>
                <linearGradient id='paint0_linear_73_871' x1='1' y1='0.0627352' x2='26.0333' y2='6.49337' gradientUnits='userSpaceOnUse'>
                  <stop stopColor='#BC9C4E' />
                </linearGradient>
              </defs>
            </svg>
          </div>
          {/* <p style={{ fontSize: '12px', fontFamily: 'Jura', marginTop: '5px' }}>The Sókn Engineering Team</p> */}
        </div>

        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '15px',
            flexDirection: 'column',
            marginTop: '-40px',
          }}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: windowWidth > 900 ? '250px' : windowWidth > 500 ? '120px' : '15px',
            }}>
            <a
              href='https://www.ibtimes.com/beyond-algorithms-sokn-engineerings-revolutionary-approach-commodities-forecasting-all-market-3777283'
              target='_blank'
              rel='noopener noreferrer'>
              <svg width='53' height='28' viewBox='0 0 53 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M15.511 11.4353C16.0055 11.4353 16.4575 11.4356 16.9094 11.4353C18.0646 11.4346 19.2207 11.4297 20.3509 11.1485C21.4421 10.877 22.3569 10.3606 22.7671 9.23616C23.089 8.35324 23.1283 7.44161 22.8864 6.53528C22.5507 5.27733 21.6164 4.66231 20.4257 4.36869C18.827 3.97433 17.1958 4.00278 15.5661 4.03572C15.549 4.036 15.5324 4.06118 15.511 4.07847V11.4353ZM15.5121 23.7521C16.8464 23.7521 18.1378 23.7847 19.4265 23.7389C20.0992 23.715 20.7795 23.6044 21.4344 23.4437C22.7981 23.1088 23.8721 22.3718 24.2694 20.9543C24.4403 20.3443 24.5103 19.6837 24.4966 19.049C24.4522 17.0094 23.406 15.7631 21.4285 15.2972C19.498 14.8423 17.5342 14.9682 15.5777 14.969C15.5593 14.969 15.5408 14.9897 15.5121 15.007V23.7521ZM10.0723 27.3825C10.2053 26.4945 10.3726 25.641 10.4509 24.7795C10.5296 23.913 10.5435 23.0387 10.5447 22.1678C10.5523 16.6648 10.5554 11.1619 10.544 5.65903C10.5409 4.14449 10.5481 2.62464 10.1736 1.13868C10.1215 0.931636 10.0639 0.725949 9.99707 0.475613C10.132 0.475613 10.2408 0.475613 10.3499 0.475613C12.9229 0.47643 15.4961 0.469079 18.0692 0.481058C19.8384 0.489362 21.6119 0.542179 23.3219 1.04326C24.0733 1.26351 24.8111 1.58531 25.4944 1.96905C26.5394 2.5559 27.2264 3.48795 27.6145 4.61549C28.1027 6.03392 28.2255 7.49469 27.8997 8.96241C27.4887 10.814 26.2857 11.998 24.574 12.7168C24.474 12.7588 24.3751 12.8039 24.2771 12.8469C24.9151 13.0669 25.5574 13.2372 26.1562 13.5043C28.128 14.3835 29.2455 15.9118 29.4992 18.0585C29.6934 19.7035 29.564 21.3166 28.9132 22.8533C28.085 24.8089 26.541 25.9734 24.5773 26.6385C22.9282 27.1972 21.2134 27.3631 19.4889 27.3788C16.3944 27.407 13.2997 27.3883 10.2052 27.3889C10.1495 27.3889 10.0939 27.3836 10.0723 27.3825Z'
                  fill='#1A1919'
                />
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M44.5139 4.13272C44.5065 4.25551 44.4966 4.34372 44.4966 4.43193C44.5039 10.9668 44.5056 17.5017 44.5264 24.0366C44.5298 25.1118 44.6649 26.1796 44.9864 27.2148C45.006 27.278 45.0166 27.344 45.0363 27.4305H38.9759C39.0822 26.9092 39.2168 26.3969 39.2853 25.8759C39.3766 25.1818 39.4681 24.481 39.47 23.7828C39.487 17.3386 39.4847 10.8943 39.488 4.4499C39.488 4.3606 39.488 4.2713 39.488 4.13653C36.6047 4.09542 33.7429 4.01524 30.9922 5.15789V0.552734H53.0001V5.1602C50.2665 4.01797 47.4078 4.09923 44.5139 4.13272Z'
                  fill='#1A1919'
                />
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M6.05463 27.4353H0C0.635982 25.3245 0.537154 23.1685 0.540285 21.0228C0.5475 16.0418 0.545867 11.0606 0.539605 6.07965C0.53838 5.15195 0.540149 4.22085 0.464599 3.29764C0.389185 2.37851 0.21821 1.46715 0.088346 0.546387H6.04292C5.5025 2.33522 5.50549 4.15795 5.50508 5.97987C5.50386 10.927 5.50223 15.8741 5.50645 20.821C5.5074 21.9302 5.51938 23.0395 5.54892 24.1481C5.57859 25.2571 5.70887 26.3549 6.05463 27.4353Z'
                  fill='#1A1919'
                />
              </svg>
            </a>

            <a
              href='https://www.usatoday.com/story/special/contributor-content/2024/07/18/skn-engineering-is-driving-commodity-returns-with-quantum-quantitative-models/74455337007/'
              target='_blank'
              rel='noopener noreferrer'>
              <img alt='' style={{ marginLeft: '30px' }} draggable={false} width={104} height={36} src='/Images/USATodayLogo.png' />
            </a>

            <a
              href='https://www.laweekly.com/sokn-engineering-a-women-owned-software-provider-is-reimagining-the-future-of-commodity-trading/'
              target='_blank'
              rel='noopener noreferrer'>
              <img alt='' draggable={false} width={104} height={36} src='/Images/LawLogo.png' />
            </a>
          </div>
        </div>

        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
          <HorizontalLine />

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
              gap: windowWidth > 1430 ? '80px' : '10px',
              marginTop: '20px',
              marginBottom: '20px',
            }}>
            {windowWidth > 1430 ? (
              <>
                <div
                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '650px', gap: '10px' }}>
                  <h1 className='bodyHeader'>What Makes Us Different</h1>

                  <p style={{ lineHeight: '150%', fontFamily: 'Lato' }}>
                    Sókn Engineering stands apart by leveraging proprietary Modular Calculus and AI-driven predictive analytics to price commodities
                    with unmatched precision. Unlike traditional models that rely on probabilities, our deterministic mathematics eliminates
                    uncertainty and adapts to market shifts in real time. Our fully autonomous trading platform, Lagertha, processes 32 trillion
                    automated thought processes, ensuring efficiency and eliminating risk.
                  </p>

                  <p style={{ lineHeight: '150%', fontFamily: 'Lato' }}>
                    Independently validated with proven ROI, Sókn Engineering’s technology not only outperforms legacy trading systems but also sets a
                    new standard in loss mitigation. By precisely identifying market extremes and implementing industry leading loss exposure, our
                    platform ensures maximum profitability with minimal downside risk. As we continue to innovate, we remain committed to redefining
                    financial intelligence and setting new industry standards.
                  </p>

                  <Link
                    draggable={false}
                    className='AltButton'
                    to={'/ourapproach'}
                    style={{ color: '#5472B8', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    Our Approach <img alt='' src='Icons/RightArrow2.svg' height={14} width={14} />
                  </Link>
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px' }}>
                  <svg width='2' height='121' viewBox='0 0 2 121' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M1 0.652344V120.189' stroke='url(#paint0_linear_208_222)' />
                    <defs>
                      <linearGradient id='paint0_linear_208_222' x1='1' y1='0.727335' x2='26.5072' y2='6.20883' gradientUnits='userSpaceOnUse'>
                        <stop stopColor='#BC9C4E' />
                      </linearGradient>
                    </defs>
                  </svg>

                  <img
                    alt=''
                    src={'Images/VikingShipWebsite.png'}
                    height={300}
                    width={420}
                    style={{
                      borderRadius: '10px',
                      border: '1px solid #bc9c4e',
                      boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
                      minWidth: '300px',
                      maxWidth: '420px',
                      height: 'auto',
                      width: 'auto',
                    }}
                  />

                  <svg width='2' height='121' viewBox='0 0 2 121' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M1 0.652344V120.189' stroke='url(#paint0_linear_208_222)' />
                    <defs>
                      <linearGradient id='paint0_linear_208_222' x1='1' y1='0.727335' x2='26.5072' y2='6.20883' gradientUnits='userSpaceOnUse'>
                        <stop stopColor='#BC9C4E' />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </>
            ) : (
              <>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px' }}>
                  <svg width='2' height='121' viewBox='0 0 2 121' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M1 0.652344V120.189' stroke='url(#paint0_linear_208_222)' />
                    <defs>
                      <linearGradient id='paint0_linear_208_222' x1='1' y1='0.727335' x2='26.5072' y2='6.20883' gradientUnits='userSpaceOnUse'>
                        <stop stopColor='#BC9C4E' />
                      </linearGradient>
                    </defs>
                  </svg>

                  <img
                    alt=''
                    src={'Images/VikingShipWebsite.png'}
                    height={300}
                    width={420}
                    style={{
                      borderRadius: '10px',
                      border: '1px solid #bc9c4e',
                      boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
                      minWidth: '200px',
                      maxWidth: '420px',
                      height: 'auto',
                      width: '100%',
                    }}
                  />

                  <svg width='2' height='121' viewBox='0 0 2 121' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M1 0.652344V120.189' stroke='url(#paint0_linear_208_222)' />
                    <defs>
                      <linearGradient id='paint0_linear_208_222' x1='1' y1='0.727335' x2='26.5072' y2='6.20883' gradientUnits='userSpaceOnUse'>
                        <stop stopColor='#BC9C4E' />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    width: '80%',
                    gap: '10px',
                  }}>
                  <h1 className='bodyHeader'>What Makes Us Different</h1>

                  <p style={{ lineHeight: '150%', fontFamily: 'Lato' }}>
                    Sókn Engineering stands apart by leveraging proprietary Modular Calculus and AI-driven predictive analytics to price commodities
                    with unmatched precision. Unlike traditional models that rely on probabilities, our deterministic mathematics eliminates
                    uncertainty and adapts to market shifts in real time. Our fully autonomous trading platform, Lagertha, processes 32 trillion
                    automated thought processes, ensuring efficiency and eliminating risk.
                  </p>

                  <p style={{ lineHeight: '150%', fontFamily: 'Lato' }}>
                    Independently validated with proven ROI, Sókn Engineering’s technology not only outperforms legacy trading systems but also sets a
                    new standard in loss mitigation. By precisely identifying market extremes and implementing industry leading loss exposure, our
                    platform ensures maximum profitability with minimal downside risk. As we continue to innovate, we remain committed to redefining
                    financial intelligence and setting new industry standards.
                  </p>

                  <Link
                    draggable={false}
                    className='AltButton'
                    to={'/ourapproach'}
                    style={{ color: '#5472B8', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    Our Approach <img alt='' src='Icons/RightArrow2.svg' height={14} width={14} />
                  </Link>
                </div>
              </>
            )}
          </div>

          <HorizontalLine />
        </div>
        <div style={{ width: '90vw', maxWidth: '1400px' }}>
          <h1 style={{ marginBottom: '20px' }} className='bodyHeader'>
            Let Us Explain
          </h1>
          <Videos windowWidth={windowWidth} />
        </div>
        <div
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: windowWidth > 1430 ? 'row' : 'column',
            gap: '40px',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: windowWidth > 1430 ? '100px' : '20px',
            marginBottom: windowWidth > 1430 ? '100px' : '0px',
          }}>
          {windowWidth > 1430 && (
            <>
              <svg
                style={{ position: 'absolute', left: '0', top: '-60px' }}
                width='539'
                height='56'
                viewBox='0 0 539 56'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M0 1H340.504C357.131 1 373.418 5.71057 387.478 14.5861L429.978 41.4139C444.038 50.2894 460.325 55 476.952 55H539'
                  stroke='url(#paint0_linear_80_1136)'
                  strokeWidth='2'
                />
                <defs>
                  <linearGradient
                    id='paint0_linear_80_1136'
                    x1='-4.91676e-07'
                    y1='0.999996'
                    x2='538.743'
                    y2='-64.1265'
                    gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#5472B8' />
                    <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
                  </linearGradient>
                </defs>
              </svg>

              <svg
                style={{ position: 'absolute', left: '0', bottom: '-60px' }}
                width='539'
                height='56'
                viewBox='0 0 539 56'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M0 55H340.504C357.131 55 373.418 50.2894 387.478 41.4139L429.978 14.5861C444.038 5.71057 460.325 1 476.952 1H539'
                  stroke='url(#paint0_linear_80_1139)'
                  strokeWidth='2'
                />
                <defs>
                  <linearGradient id='paint0_linear_80_1139' x1='-4.91676e-07' y1='55' x2='538.743' y2='120.127' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#5472B8' />
                    <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
                  </linearGradient>
                </defs>
              </svg>
            </>
          )}

          {windowWidth <= 1430 && (
            <div
              style={{
                width: '90vw',
                maxWidth: '475px',
                minWidth: '200px',
                height: 'fit-content',
                paddingTop: 9,
                paddingBottom: 9,
                background: '#3F5896',
                borderRadius: 10,
                overflow: 'hidden',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 13,
                display: 'inline-flex',
              }}>
              <div
                className='full'
                style={{
                  marginLeft: '20px',
                  marginRight: '20px',
                  width: '-moz-available',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  display: 'flex',
                }}>
                <div style={{ color: 'white', fontSize: 20, fontFamily: 'Jura', fontWeight: '700', wordWrap: 'break-word' }}>
                  Multi-Revenue Opportunities
                </div>
                <div data-svg-wrapper style={{ position: 'relative' }}>
                  <img alt='' src='Icons/MoneyBag.svg' height={24} width={24} />
                </div>
              </div>
              <svg width='100%' height='2' viewBox='0 0 405 2' preserveAspectRatio='none' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M0 1L307.1 0.999973L405 0.999965' stroke='url(#paint0_linear_164_116)' strokeWidth='2' />
                <defs>
                  <linearGradient id='paint0_linear_164_116' x1='0' y1='1' x2='412.06' y2='2.76829' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#BC9C4E' />
                    <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
                  </linearGradient>
                </defs>
              </svg>

              <img
                alt='Commodities - Funds - Analytics'
                src='SpecialSVGs/Opportunities.svg'
                width={475}
                height={140}
                style={{ maxWidth: '475px', minWidth: '200px', height: 'auto', width: '100%' }}
              />

              <div
                style={{
                  width: '90%',
                  color: 'white',
                  fontSize: 16,
                  fontFamily: 'Lato',
                  fontWeight: '400',
                  wordWrap: 'break-word',
                  paddingBottom: '10px',
                }}>
                Sókn Engineering’s technology extends beyond commodity trading, unlocking multiple revenue streams across financial markets. From
                proprietary analytics for hedge funds, commodity pricing, and institutional traders to a fully autonomous commodity pool fund and
                future blockchain applications, our innovations create diverse monetization pathways while maximizing shareholder value.
              </div>
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <Card
              icon={'Icons/Shield.svg'}
              title={'Our Proprietary Models'}
              text={
                'Sókn Engineering’s AI-driven models leverage Modular Calculus to precisely determine market movements. Instead of relying on traditional forecasting methods, our technology analyzes real-time price pressures and algorithmic patterns to identify market shifts with certainty. This deterministic approach eliminates guesswork, enabling smarter, data-driven decisions with unparalleled accuracy'
              }
              buttonURL={'/ourapproach#soknmathmodels'}
            />
            <Card
              icon={'Icons/TestingZone.svg'}
              title={'Modular Calculus'}
              text={
                'Proprietary to Sókn Engineering, Modular Calculus is a revolutionary mathematical framework that moves beyond conventional theorem-based models. By dynamically restructuring equations in a torus composition set, it allows for real-time market forecasting with precision previously thought impossible.'
              }
              buttonURL={'/ourapproach'}
            />
          </div>

          {windowWidth > 1430 && (
            <div
              style={{
                width: '90vw',
                maxWidth: '475px',
                minWidth: '200px',
                height: 'fit-content',
                paddingTop: 9,
                paddingBottom: 9,
                background: '#3F5896',
                borderRadius: 10,
                overflow: 'hidden',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 13,
                display: 'inline-flex',
              }}>
              <div
                className='full'
                style={{
                  marginLeft: '20px',
                  marginRight: '20px',
                  width: '-moz-available',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  display: 'flex',
                }}>
                <div style={{ color: 'white', fontSize: 20, fontFamily: 'Jura', fontWeight: '700', wordWrap: 'break-word' }}>
                  Multi-Revenue Opportunities
                </div>
                <div data-svg-wrapper style={{ position: 'relative' }}>
                  <img alt='' src='Icons/MoneyBag.svg' height={24} width={24} />
                </div>
              </div>
              <svg width='100%' height='2' viewBox='0 0 405 2' preserveAspectRatio='none' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M0 1L307.1 0.999973L405 0.999965' stroke='url(#paint0_linear_164_116)' strokeWidth='2' />
                <defs>
                  <linearGradient id='paint0_linear_164_116' x1='0' y1='1' x2='412.06' y2='2.76829' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#BC9C4E' />
                    <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
                  </linearGradient>
                </defs>
              </svg>

              <img
                alt='Commodities - Funds - Analytics'
                src='SpecialSVGs/Opportunities.svg'
                width={475}
                height={140}
                style={{ maxWidth: '475px', minWidth: '200px', height: 'auto', width: '100%' }}
              />

              <div
                style={{
                  width: '90%',
                  color: 'white',
                  fontSize: 16,
                  fontFamily: 'Lato',
                  fontWeight: '400',
                  wordWrap: 'break-word',
                  paddingBottom: '10px',
                }}>
                Sókn Engineering’s technology extends beyond commodity trading, unlocking multiple revenue streams across financial markets. From
                proprietary analytics for hedge funds, commodity pricing, and institutional traders to a fully autonomous commodity pool fund and
                future blockchain applications, our innovations create diverse monetization pathways while maximizing shareholder value.
              </div>
            </div>
          )}

          {windowWidth > 1430 && (
            <>
              <svg
                style={{ position: 'absolute', right: '0', top: '-60px' }}
                width='539'
                height='56'
                viewBox='0 0 539 56'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M539 1H198.496C181.869 1 165.582 5.71057 151.522 14.5861L109.022 41.4139C94.9622 50.2894 78.6753 55 62.0482 55H0'
                  stroke='url(#paint0_linear_80_1137)'
                  strokeWidth='2'
                />
                <defs>
                  <linearGradient id='paint0_linear_80_1137' x1='539' y1='0.999996' x2='0.256954' y2='-64.1265' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#5472B8' />
                    <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
                  </linearGradient>
                </defs>
              </svg>

              <svg
                style={{ position: 'absolute', right: '0', bottom: '-60px' }}
                width='539'
                height='56'
                viewBox='0 0 539 56'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M539 55H198.496C181.869 55 165.582 50.2894 151.522 41.4139L109.022 14.5861C94.9622 5.71057 78.6753 1 62.0482 1H0'
                  stroke='url(#paint0_linear_80_1138)'
                  strokeWidth='2'
                />
                <defs>
                  <linearGradient id='paint0_linear_80_1138' x1='539' y1='55' x2='0.256954' y2='120.127' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#5472B8' />
                    <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
                  </linearGradient>
                </defs>
              </svg>
            </>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <Card
              icon={'Icons/Axe.svg'}
              title={'Machine Learning'}
              text={
                'Sókn Engineering’s AI-driven models leverage self-learning and self-scripting capabilities to continuously adapt to market dynamics. Unlike traditional algorithms that degrade over time, our technology refines itself in real time, ensuring ever-improving accuracy and efficiency in trade execution.'
              }
              buttonURL={'/ourapproach#soknai'}
            />
            <Card
              icon={'Icons/InspectMoney.svg'}
              title={'Loss Mitigation'}
              text={
                'Sókn Engineering’s predictive models identify exact price inversion points, allowing trades to be executed with minimal risk exposure. This deterministic approach eliminates the guesswork of traditional trading, ensuring highly controlled losses while maximizing returns in any market condition.'
              }
              buttonURL={'/provenandevolving#section1'}
            />
          </div>
        </div>
        <Link
          to={'contact'}
          draggable={false}
          className='AltButton'
          style={{ fontFamily: 'Jura', fontWeight: 'bold', color: '#5472B8', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          Would you like to learn more? <img alt='' src='Icons/RightArrow2.svg' height={14} width={14} />
        </Link>
      </div>
    </>
  );
}

function Videos({ windowWidth }) {
  const breakpoint = 1430;
  return (
    <>
      <Swiper
        id='Videos'
        slidesPerView={windowWidth >= breakpoint ? 3 : 1}
        spaceBetween={10}
        loop={windowWidth >= breakpoint ? true : false}
        centeredSlides={windowWidth >= breakpoint ? false : true}
        centerInsufficientSlides
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>';
          },
        }}
        modules={[Autoplay, Pagination]}>
        <SwiperSlide>
          <Video
            urlRef={'https://youtu.be/3y0WaURICPU'}
            coverImage={'Images/VideoThumbnails/ModelApproach.png'}
            length={'2m'}
            title={'Our Modeling Approach'}
            windowWidth={windowWidth}
          />
        </SwiperSlide>
        <SwiperSlide>
          <Video
            urlRef={'https://youtu.be/N3BgYuVBd7g'}
            coverImage={'Images/VideoThumbnails/ModualarMathmatics.png'}
            length={'3m'}
            title={'Modular Mathematics'}
            windowWidth={windowWidth}
          />
        </SwiperSlide>
        <SwiperSlide>
          <Video
            urlRef={'https://youtu.be/KLfejXLJOxo'}
            coverImage={'Images/VideoThumbnails/ApplicationsModels.png'}
            length={'1m'}
            title={'Applications of our Models'}
            windowWidth={windowWidth}
          />
        </SwiperSlide>
      </Swiper>
    </>
  );
}

function Video({ title, length, urlRef, coverImage, windowWidth }) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div className='videoContainer'>
          <div style={{ zIndex: '0', position: 'absolute', display: 'flex', flexDirection: 'column', gap: '5px', marginTop: '10px' }}>
            <div className='videoTitle'>
              <h1 style={{ fontSize: '18px' }} className='headerText'>
                {title}
              </h1>
            </div>

            <div className='videoTitle'>
              <h2 style={{ fontSize: '10px' }} className='headerText'>
                {length}
              </h2>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img
              onClick={() => {
                setOpen(true);
              }}
              alt='CoverImage'
              src={coverImage}
              width={'100%'}
              height={'100%'}
              style={{ cursor: 'pointer', borderRadius: '10px', userSelect: 'none' }}
            />

            <img
              onClick={() => {
                setOpen(true);
              }}
              alt='Watch'
              src={'Icons/PlayButton.svg'}
              width={'50px'}
              height={'50px'}
              style={{ position: 'absolute', zIndex: '0', cursor: 'pointer', backgroundColor: '#5472b8', borderRadius: '10px', userSelect: 'none' }}
            />
          </div>

          <Dialog
            slotProps={{
              paper: {
                style: {
                  maxHeight: '95vh',
                  width: '100vw',
                  border: 2,
                  borderColor: '#5472b8',
                  borderRadius: 10,
                  margin: '10px',
                  maxWidth: '100%',
                },
              },
            }}
            fullWidth
            maxWidth={false}
            open={open}
            onClose={() => setOpen(false)}>
            <DialogTitle style={{ color: '#bc9c4e' }}>
              {title} - ({length})
            </DialogTitle>

            <div onClick={() => setOpen(false)} className='modalButton' style={{ position: 'absolute' }}>
              <img style={{ cursor: 'pointer' }} alt='close' src='Icons/Close.svg' height={20} width={20} />
            </div>

            <DialogContent
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: windowWidth > 750 ? '90vh' : windowWidth > 500 ? '50vh' : '25vh',
              }}>
              <ReactPlayer width={'95vw'} height={'100%'} pip={false} controls url={urlRef} playing />
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </>
  );
}

function Card({ title, text, icon, buttonURL }) {
  return (
    <>
      <div
        style={{
          width: '90vw',
          maxWidth: '400px',
          minWidth: '200px',
          paddingTop: 10,
          paddingBottom: 10,
          background: '#3F5896',
          borderRadius: 10,
          overflow: 'hidden',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 10,
          display: 'flex',
        }}>
        <div>
          <div style={{ width: '100%', justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex' }}>
            <div style={{ marginLeft: '20px', color: 'white', fontSize: 20, fontFamily: 'Jura', fontWeight: '700', wordWrap: 'break-word' }}>
              {title}
            </div>
            <div data-svg-wrapper style={{ marginRight: '20px', position: 'relative' }}>
              <img alt='' src={icon} height={24} width={24} />
            </div>
          </div>

          <svg width='100%' height='2' viewBox='0 0 405 2' preserveAspectRatio='none' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 1L307.1 0.999973L405 0.999965' stroke='url(#paint0_linear_164_116)' strokeWidth='2' />
            <defs>
              <linearGradient id='paint0_linear_164_116' x1='0' y1='1' x2='412.06' y2='2.76829' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#BC9C4E' />
                <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
              </linearGradient>
            </defs>
          </svg>
        </div>

        <div
          style={{
            width: '90%',
            height: 'fit-content',
            color: 'white',
            fontSize: 16,
            fontFamily: 'Lato',
            fontWeight: '400',
            wordWrap: 'break-word',
          }}>
          {text}
        </div>

        <NavButton reload link={buttonURL} text={'Learn More'} />
      </div>
    </>
  );
}
